import { createFormData } from 'src/helpers';
import { IMenuSetResponseBody } from 'src/api/getMenuSet';
import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IDuplicateMenuSetRequest } from './types';

export const duplicateMenuSet = async (
  menuSetId: string,
  payload: IDuplicateMenuSetRequest,
): Promise<IMenuSetResponseBody> => {
  const res = await fetch(`${API_URL}/menus/menu-sets/${menuSetId}/duplicate`, {
    method: 'POST',
    body: createFormData(payload),
  });

  if (!res.ok) {
    let errorBody: { message?: string } | null;
    try {
      errorBody = await res.json();
    } catch {
      errorBody = null;
    }
    throw new Error(errorBody?.message || res.statusText);
  }

  return res.json();
};
